/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mins_UnitInputs */

const en_mins_unit = /** @type {(inputs: Mins_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min(s)`)
};

const fr_mins_unit = /** @type {(inputs: Mins_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const de_mins_unit = /** @type {(inputs: Mins_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min(s)`)
};

const it_mins_unit = /** @type {(inputs: Mins_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minuti`)
};

const ru_mins_unit = /** @type {(inputs: Mins_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`мин(с)`)
};

const es_mins_unit = /** @type {(inputs: Mins_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min(s)`)
};

const zh_cn2_mins_unit = /** @type {(inputs: Mins_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小值`)
};

const ja_mins_unit = /** @type {(inputs: Mins_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

const hi_mins_unit = /** @type {(inputs: Mins_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिनट(ओं)`)
};

const pt_pt2_mins_unit = /** @type {(inputs: Mins_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min(s)`)
};

/**
* | output |
* | --- |
* | "min(s)" |
*
* @param {Mins_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const mins_unit = /** @type {((inputs?: Mins_UnitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mins_UnitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_mins_unit(inputs)
	if (locale === "de") return de_mins_unit(inputs)
	if (locale === "it") return it_mins_unit(inputs)
	if (locale === "ru") return ru_mins_unit(inputs)
	if (locale === "es") return es_mins_unit(inputs)
	if (locale === "zh-CN") return zh_cn2_mins_unit(inputs)
	if (locale === "ja") return ja_mins_unit(inputs)
	if (locale === "hi") return hi_mins_unit(inputs)
	if (locale === "pt-PT") return pt_pt2_mins_unit(inputs)
	return en_mins_unit(inputs)
});